/*
 *
 * DocumentsStatementsCustomDownloadModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 09-Apr-2025
*/

import DocumentsStatementsCustomDownloadModal from './DocumentsStatementsCustomDownloadModalContainer'

export default DocumentsStatementsCustomDownloadModal
